import React from 'react'

import cn from '../../libs/class-names'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  space?: '70' | '80' | '90' | '100' | '200' | '300' | '400' | '500'
  spaceRow?: '60' | '70' | '80' | '90'
  align?: 'left' | 'right' | 'center'
  mAlign?: 'left' | 'right' | 'center'
  lAlign?: 'left' | 'right' | 'center'
  alignItems?: 'center' | 'top' | 'bottom' | 'baseline'
  mobileBlock?: boolean
  noWrap?: boolean
}

const ActionBar = ({
  classNames,
  children,
  space = '100',
  spaceRow = '90',
  align = 'left',
  mAlign,
  lAlign,
  alignItems = 'center',
  mobileBlock = false,
  noWrap = false,
}: Props) => (
  <div
    className={cn(
      'ActionBar',
      {
        [`space-${space}`]: !!space,
        [`spaceRow-${spaceRow}`]: !!spaceRow,
        [`align-${align}`]: true,
        [`m-align-${mAlign}`]: !!mAlign,
        [`l-align-${lAlign}`]: !!lAlign,
        [`alignItems-${alignItems}`]: true,
        mobileBlock,
        noWrap,
      },
      classNames
    )}
  >
    {children}
  </div>
)

export default ActionBar
